/**
 * @fileoverview Redux store configuration for KaraoNow.
 * @summary Main Redux store that combines all feature slices.
 *
 * @package KaraoNow
 * @module apps/front/src/store
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */
import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice.js'
import eventsReducer from './slices/eventsSlice.js'
import venuesReducer from './slices/venuesSlice.js'
import queueReducer from './slices/queueSlice.js'
import singersReducer from './slices/singersSlice.js'
import songsReducer from './slices/songsSlice.js'

/**
 * @summary Main Redux store configuration.
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 */
export const store = configureStore({
  reducer: {
    auth: authReducer,
    events: eventsReducer,
    venues: venuesReducer,
    queue: queueReducer,
    singers: singersReducer,
    songs: songsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
  devTools: import.meta.env.DEV,
})

// Export types for TypeScript
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
